// Constantes de UI da feature — fora dos componentes para não recriar a cada render.

// Filtro de status na URL (`?active=`). "all" = sem filtro (param ausente).
export const STATUS_FILTER_VALUES = [
  "all",
  "true",
  "false",
] as const

export type StatusFilterValue =
  (typeof STATUS_FILTER_VALUES)[number]

// Chip suave: emerald = ativo, gray = inativo, sempre com texto + dot.
export const STATUS_CHIP_CLASSES = {
  active: {
    chip: "border-emerald-200 bg-emerald-50 text-emerald-700",
    dot: "bg-emerald-500",
  },
  inactive: {
    chip: "border-gray-200 bg-gray-50 text-gray-700",
    dot: "bg-gray-400",
  },
} as const

// Acento do card na lista: inativo esmaece, ativo ganha a borda emerald.
export const CARD_ACCENT_CLASSES = {
  active: "border-l-emerald-500",
  inactive: "border-l-gray-300",
} as const

export const SKELETON_ROWS = 3
